export const CONTAINER_THEMES = {
    auto: 'auto',
    dark: 'dark',
    light: 'light',
};
